import { createSlice } from '@reduxjs/toolkit';

/**
 * Minimal SSR bridge slice.
 *
 * configure() dispatches to this slice on the server.
 * ws-scripts serializes this to __INITIAL_STATE__.
 * Widget.jsx reads hydrated state ONCE on mount, then passes to Context providers.
 * Client components do NOT use useSelector/useDispatch against this slice.
 */
const initialState = {
	accountData: null,
	incentives: [],
	vehicles: {},
	showcaseMappings: null,
	loading: true,
	errors: [],
	// ws-scripts strips accountId/siteId from the framework requestData payload
	// before client hydration; carry them here so the deferred-images hook can
	// read accountId on the client.
	requestContext: { accountId: null, locale: null }
};

/* eslint-disable no-param-reassign -- Redux Toolkit uses Immer for immutable updates */
const incentivesSearchSlice = createSlice({
	name: 'incentivesSearch',
	initialState,
	reducers: {
		dataLoaded(state, action) {
			state.accountData = action.payload;
		},
		incentivesLoaded(state, action) {
			// payload is the normalized raw incentives array; byVehicle is derived client-side
			state.incentives = action.payload;
			state.loading = false;
		},
		vehicleDataLoaded(state, action) {
			state.vehicles = action.payload;
		},
		dataLoadError(state, action) {
			state.errors.push(action.payload);
			state.loading = false;
		},
		showcaseMappingsLoaded(state, action) {
			state.showcaseMappings = action.payload;
		},
		showcaseMappingsError(state) {
			state.showcaseMappings = null;
		},
		requestContextLoaded(state, action) {
			state.requestContext = action.payload;
		}
	}
});
/* eslint-enable no-param-reassign */

export const {
	dataLoaded,
	incentivesLoaded,
	vehicleDataLoaded,
	dataLoadError,
	showcaseMappingsLoaded,
	showcaseMappingsError,
	requestContextLoaded
} = incentivesSearchSlice.actions;

export default incentivesSearchSlice.reducer;
